import { ARCHBASE_IOC_API_TYPE } from '@archbase/core'

/**
 * Símbolos de injeção de dependência (Inversify).
 *
 * Os do Archbase são reexportados por conveniência; abaixo deles vêm os do doclenz.
 */
export const API_TYPE = {
  // Archbase (obrigatórios)
  Authenticator: ARCHBASE_IOC_API_TYPE.Authenticator,
  TokenManager: ARCHBASE_IOC_API_TYPE.TokenManager,
  ApiClient: ARCHBASE_IOC_API_TYPE.ApiClient,
  User: ARCHBASE_IOC_API_TYPE.User,
  Profile: ARCHBASE_IOC_API_TYPE.Profile,
  Group: ARCHBASE_IOC_API_TYPE.Group,
  Resource: ARCHBASE_IOC_API_TYPE.Resource,
  ApiToken: ARCHBASE_IOC_API_TYPE.ApiToken,

  // Doclenz
  DoclenzKey: Symbol.for('DoclenzKey'),
  DoclenzUsage: Symbol.for('DoclenzUsage'),
  DoclenzJob: Symbol.for('DoclenzJob'),
  DoclenzExtract: Symbol.for('DoclenzExtract'),
  DoclenzSettings: Symbol.for('DoclenzSettings'),
  DoclenzAudit: Symbol.for('DoclenzAudit'),
}
